<template>
  <div>
    <!-- <ValidationProvider :name="$t(itemName)" rules="required" v-slot="{ errors }"> -->
    <v-autocomplete
      v-model="editedItem"
      :items="allItem"
      :item-text="setItemText"
      item-value="Id"
      required
      return-object
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_results')"
      @change="chooseItem"
      :ref="refName"
      @keyup.enter="keyupEnter"
    >
      <!-- :error-messages="errors[0]" -->
      <template v-slot:item="data">
        <template>
          <v-list-item-content>
            <v-list-item-title>{{ data.item.Name }} </v-list-item-title>
            <v-list-item-subtitle>{{ data.item.Number }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
      <template v-slot:selection="{ item }">
        {{ setSelectText(item) }}
      </template>
      <template v-slot:label>
        <span class="red--text">
          <strong>* </strong>
        </span>
        {{ $t(itemName) }}
      </template>
    </v-autocomplete>
    <!-- </ValidationProvider> -->
  </div>
</template>

<script>
import { HttpItem } from '@/js/http-Manager'
export default {
  name: 'ItemAutocompleteGroupListForEg',
  props: {
    fatherEditedItem: {
      type: Object
    },
    itemName: {
      type: String
    },
    selectItemId: {
      type: String
    },
    selectItemType: {
      type: String
    },
    refName: {
      type: String
    },
    editedWorkItemIndex: {
      type: Number
    },
    customerDeviceType: {
      type: Number
    }
  },
  components: {},
  data: () => ({
    allItem: [],
    isLoadingItem: false,
    editedItem: {
      Id: '',
      Number: '',
      Name: ''
    },
    defaultItem: {
      Id: '',
      Number: '',
      Name: ''
    }
  }),
  async mounted () {
    await this.setItem(this.fatherEditedItem)
  },
  watch: {
    async fatherEditedItem (val) {
      await this.setItem(val)
    },
    async customerDeviceType () {
      await this.getItems()
    }
  },
  computed: {
    selectItemFinal () {
      return this.editedWorkItemIndex !== -1 || this.fatherEditedItem.ItemId !== ''
        ? this.fatherEditedItem.ItemId
        : this.selectItemId
    }
  },
  methods: {
    async setItem (val) {
      await this.getItems()
      if (!val.ItemId) {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
      } else {
        if (!this.editedItem) {
          this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        }
        this.editedItem.Id = val.ItemId
        this.editedItem.Number = val.Number
        this.editedItem.Name = val.Name
        this.editedItem.Unit = val.Unit
        this.editedItem.Price = val.Price
        this.editedItem.IsMonthItem = val.IsMonthItem
        this.editedItem.IsDelete = val.IsDelete
        this.editedItem.StoreNo = val.StoreNo
        this.editedItem.RepairPrice = val.RepairPrice
        this.editedItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
        this.editedItem.RentWarrantyPeriod = val.RentWarrantyPeriod
        this.editedItem.WarrantyPeriod = val.WarrantyPeriod
        this.editedItem.HasSerialNumber = val.HasSerialNumber
        this.editedItem.IsExistResume = val.IsExistResume
        this.editedItem.Type = val.Type
        this.editedItem = JSON.parse(JSON.stringify(this.editedItem))
      }
    },
    keyupEnter (event) {
      this.$refs[this.refName].isMenuActive = false
      this.$refs[this.refName].isFocused = false
      this.$emit('keyupEnter', event)
    },
    async chooseItem () {
      if (this.editedItem) {
        this.$emit('setEditedItem', this.editedItem)
      } else {
        this.$emit('setEditedItem', this.defaultItem)
      }
    },
    setSelectText (item) {
      return item.Name
    },
    setItemText (item) {
      return item.Number + ' - ' + item.Name
    },
    async getItems () {
      this.isLoadingItem = true
      let param = {
        SelectItemId: this.selectItemFinal,
        SelectItemType: this.selectItemType,
        CustomerDeviceType: this.customerDeviceType ? this.customerDeviceType : null
      }
      let response = await HttpItem.GetEgItemGroupList(param)
      if (response.status === 200) {
        this.allItem = response.data.Data
      } else {
        this.allItem = []
      }
      this.isLoadingItem = false
    }
  }
}
</script>
